import { useContext, useMemo } from 'react';
import { Row, Col, Input } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Table } from '@octano/global-ui';

import { TranslationsKeys } from '../../../../locales/translations';
import { CourseFormFields } from '../../types/details';
import { CourseFormContext } from '../../provider/CourseProvider';
import SectionTitle from '../../../../components/Text/SectionTitle';

const CourseAttendanceSection = () => {
  const { t } = useTranslation(TranslationsKeys.COURSES_DETAILS);

  const { watch } = useFormContext<CourseFormFields>();

  const { formData } = useContext(CourseFormContext);
  const { activities = [] } = formData;

  const [attendance] = watch(['attendance']);

  const validActivityTypes = useMemo(
    () =>
      activities?.filter((e) =>
        attendance?.map((a) => a.activityTypeId).includes(+e.value),
      ) ?? [],
    [activities, attendance],
  );

  if (!activities?.length) {
    return <></>;
  }

  return (
    <Row>
      <Col xs={12} className="pt-4 pb-4">
        <SectionTitle text={t(`assistanceRequired`)} />
      </Col>
      <Col xs={12}>
        <Table
          columns={[
            {
              columnName: 'label',
              width: '50%',
              thClassName: 'text-center',
              tdClassName: 'text-center',
              headerText: t(`activityType`),
            },
            {
              columnName: 'id',
              width: '50%',
              thClassName: 'text-center',
              tdClassName: 'text-center',
              headerText: t(`obligatoryAttendance`),
              cellFormat: ({ row }) => (
                <div
                  className="d-flex m-auto align-items-center"
                  style={{ maxWidth: '65px' }}
                >
                  <Input
                    name={`attendance_${row.label}`}
                    type="text"
                    disabled
                    value={
                      attendance.find((att) => att.activityTypeId === row.value)
                        ?.minPercentage ?? 0
                    }
                  />
                  <span className="pl-2">%</span>
                </div>
              ),
            },
          ]}
          data={validActivityTypes}
        />
      </Col>
    </Row>
  );
};

export default CourseAttendanceSection;
